import React, { useState, useEffect } from 'react';
import axios from 'axios';
import translations from '../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';

function ForTradeTradingTemplate({ userId, setFormData,setButtonToggle,buttonToggle,formData,formSelectStyles }) {
  const userIdForUsage = userId;
  const [tradingTemplates, setTradingTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [selectedTemplateTitle, setSelectedTemplateTitle] = useState(''); // To store the selected title
  //const [toggleDetails, setToggleDetails] = useState(false); // For toggling details visibility
  const [isOpen, setIsOpen] = useState(false);
  const API_BASE_URL = `${process.env.REACT_APP_API_BASE}`;

  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.ForTradeTradingTemplate[key][currentLang]; // Adjust the path according to your JSON structure


// put near the top of the component
const splitList = (s) =>
  (s || "")
    .split(",")
    .map(v => v.trim())
    .filter(Boolean); // removes "", spaces, stray commas

const players      = splitList(selectedTemplate.PlayerNames);
const sets         = splitList(selectedTemplate.SetNames);
const cardNames    = splitList(selectedTemplate.CardNames);
const variations   = splitList(selectedTemplate.VariationNames);

  useEffect(() => {
    fetchTradingTemplates();
  }, []);

  useEffect(() => {
    console.log('template trade', tradingTemplates);
  
  }, [tradingTemplates]);

  const fetchTradingTemplates = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/get/trading-preferences/${userIdForUsage}`,   {
        withCredentials: true, // ✅ sends cookies/session
      });
      setTradingTemplates(response.data);
    } catch (error) {
      console.error('Error fetching trading templates:', error);
    }
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setSelectedTemplateTitle(template.TemplateTitle); // Set the selected title
  };

  const handleTemplateTitleChange = (event) => {
    const selectedTitle = event.target.value;
    const selectedTemplate = tradingTemplates.find((template) => template.TemplateTitle === selectedTitle);

    if (selectedTemplate) {
      setSelectedTemplate(selectedTemplate);
      setSelectedTemplateTitle(selectedTitle);
      setFormData((prevData) => ({
        ...prevData,
        TradingTemplate: selectedTemplate.TradingPreferencesId,
      }));
    } else {
      setSelectedTemplate({});
      setSelectedTemplateTitle('');
    }
  };

  const toggleDetails = () => {
    setIsOpen((prev) => !prev);
  };
  return (
    <div >
     <h2 className="tt-title">{t('Trading Templates')}</h2>

<select
  value={selectedTemplateTitle}
  onChange={handleTemplateTitleChange}
  className="tt-select"
>
  <option value="">{t('Select a template title')}</option>
  {tradingTemplates.map((tpl) => (
    <option key={tpl.TradingPreferencesId} value={tpl.TemplateTitle}>
      {tpl.TemplateTitle}
    </option>
  ))}
</select>

{formData?.SeeMore && selectedTemplate.TradingPreferencesId && (
  <div className={`tt-card ${formData?.SeeMore ? 'is-open' : ''}`}>
    <div className="tt-grid">
      {/* Left column */}
      <div className="tt-col">
        <div className="tt-section">
          <div className="tt-k">{t('Type of Card')}:</div>
          <div className="tt-v">{selectedTemplate.TypeOfCard}</div>
        </div>

       {players.length > 0 && ( <div className="tt-section">
          <div className="tt-k">{t('Player Names')}:</div>
          <ul className="tt-chiplist">
            {players.map((n, i) => (
          <span key={i} className="tt-chip">{n}</span>
        ))}
          </ul>
        </div>)}

     {cardNames.length > 0 && (
  <div className="tt-section">
    <div className="tt-k">{t("Card's Name")}:</div>
    <ul className="tt-chiplist">
      {cardNames.map((n, i) => (
        <li key={`c-${i}`} className="tt-chip">{n}</li>
      ))}
    </ul>
  </div>
)}
      </div>

      {/* Right column */}
      <div className="tt-col">
      {sets.length > 0 && (
  <div className="tt-section">
    <div className="tt-k">{t('Set Names')}:</div>
    <ul className="tt-chiplist">
      {sets.map((n, i) => (
        <li key={`s-${i}`} className="tt-chip">{n}</li>
      ))}
    </ul>
  </div>
)}

      {variations.length > 0 && (
  <div className="tt-section">
    <div className="tt-k">{t('Variation Names')}:</div>
    <ul className="tt-chiplist">
      {variations.map((n, i) => (
        <li key={`v-${i}`} className="tt-chip">{n}</li>
      ))}
    </ul>
  </div>
)}

        <div className="tt-flags">
          {selectedTemplate.isOnlyTrueRookie === 1 && <span className="tt-flag">{t('Only True Rookie')}</span>}
          {selectedTemplate.isOnlyRookie     === 1 && <span className="tt-flag">{t('Only Rookie')}</span>}
          {selectedTemplate.isOnlyAuto       === 1 && <span className="tt-flag">{t('Only Autograph')}</span>}
          {selectedTemplate.isOnlyRPA        === 1 && <span className="tt-flag">{t('Only Rookie-Patch-Auto')}</span>}
          {selectedTemplate.isOnlyNumber     === 1 && <span className="tt-flag">{t('Only Numbered')}</span>}
        </div>

        {selectedTemplate.OtherDetails && (
          <div className="tt-section">
            <div className="tt-k">{t('Other Details')}:</div>
            <div className="tt-note">{selectedTemplate.OtherDetails}</div>
          </div>
        )}
      </div>
    </div>

    <div className="tt-actions">
      <button
        type="button"
        className="btn-ghost"
        onClick={() =>
          setFormData(prev => ({ ...prev, SeeMore: !prev.SeeMore }))
        }
      >
        {formData?.SeeMore ? t('SeeLess') : t('SeeMore')}
      </button>
    </div>
  </div>
)}
    </div>
  );
}

export default ForTradeTradingTemplate;
